<div class="container-fluid">
    <div class="row">
        <!-- <div class="col-sm-3 col-md-3 col-lg-4"></div> -->
        <div class="col-sm-12">
             <div class="header-container">
                <img src="images/sage-black-logo.svg" alt="Sage" width="120px" height="67.505px">
                <span class="customer-portal-text">{{'signIn.customerPortal' | translate}}</span>
            </div>
            <hr>
            <!-- <p class="signin-header">
                Sign up to the portal
            </p> -->
            <h6>{{'signUpCustomerType.signUpToThePortal' | translate}}</h6>
            <div class="row">
                <div class="col-1">
                    <mat-radio-button (click)="changeExistingCustomer(true)" [checked]="existingCustomer"></mat-radio-button>
                </div>
                <div class="col-11 pt-2">
                    <p class="label-name mb-1">
                        {{'signUpCustomerType.iAmAnExistingCustomer' | translate}}
                        
                    </p>
                    <div class="row">
                        <div class="col-11">
                            <!-- <input class="form-control" [disabled]="!existingCustomer()" 
                    [(ngModel)]="accountId" placeholder="Account ID"> -->
                            <mat-form-field class="w-100" appearance="outline">
                                <!-- <input matInput placeholder="" [formControl]="accountId"
                                    [value]="accountId.value ? (accountId.value.length > 7 ? 'X'.repeat(accountId.value.length - 7) + accountId.value.slice(-7) : accountId.value) : ''"
                                    (input)="accountId.setValue($any($event.target).value)" autocomplete="off"> -->
                                    <input matInput placeholder="" [formControl]="accountId" (change)="maskAccountId()" (focus)="onFocus()"  maxlength="16">
                             <!-- <input matInput placeholder="" [formControl]="accountId" (change)="maskAccountId()" (focus)="onFocus()"  maxlength="10"> -->

                                    @if (accountId.errors?.['required']) {
                        <mat-error class="font-sm">{{'signUpCustomerType.pleaseProvideAnAccountId' | translate}}</mat-error>
                        }
                        @if (accountId.errors?.['minlength'] || accountId.errors?.['pattern'] || accountId.errors?.['maxlength']) {
                        <mat-error class="font-sm">{{'signUpCustomerType.pleaseProvideValidAccountId' | translate}}</mat-error>
                        }
                            </mat-form-field>
                        </div>
                        <div class="col-1 d-flex flex-column pt-2">
                            <!-- @if (!existingCustomer) {
                                <svg tabindex="0" role="button" (click)="openImageDialog()" (keydown)="null" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                class="bi bi-question-circle" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                <path
                                    d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94" />
                            </svg>
                            } -->
                        </div>
                    </div>
                    <p class="info font-sm mb-0">
                        {{'signUpCustomerType.thisWillBeSignUp' | translate}}
                    </p>
                </div>
            </div>

            <div class="row">
                <div class="col-1">
                    <mat-radio-button (click)="changeExistingCustomer(false)" [checked]="!existingCustomer"></mat-radio-button>
                </div>
                <div class="col-11 pt-2">
                    <p class="label-name mb-1">
                            {{'signUpCustomerType.iAmANewSageCustomer' | translate}}

                        
                    </p>
                    <div class="row">
                        <div class="col-11">
                            <!-- <input class="form-control" [disabled]="existingCustomer()" [(ngModel)]="companyName" placeholder="Company Name"> -->
                            <mat-form-field class="w-100" appearance="outline">
                                <input matInput placeholder="" [formControl]="companyName">
                             <input matInput placeholder="" [formControl]="companyName" maxlength="40">
                                @if (companyName.errors?.['required']) {
                        <mat-error class="font-sm">{{'signUpCustomerType.pleaseprovideCompanyName' | translate}}</mat-error>
                        }
                        @if (companyName.errors?.['minlength'] || companyName.errors?.['pattern'] || companyName.errors?.['maxlength']) {
                        <mat-error class="font-sm">{{'signUpCustomerType.pleaseprovideValidCompanyName' | translate}}</mat-error>
                        }
                            </mat-form-field>
                        </div>
                        <div class="col-1 d-flex flex-column pt-2">
                            @if (!existingCustomer) {
                                <svg tabindex="0" role="button" (click)="openTextDialog()" (keydown)="null" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                class="bi bi-question-circle" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                <path
                                    d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94" />
                            </svg>
                            }
                        </div>
                    </div>
                    <p class="info font-sm mb-0">
                        {{'signUpCustomerType.thisWillSignYouUp' | translate}}

                        
                    </p>

                </div>

                
            </div>
            <div class="row mt-3">
                <!-- <div class="col-1"></div> -->
                <div class="col-12">
                    <button type="button" class="btn btn-success w-100 font-sm"
                    (click)="continue()" [disabled]="(existingCustomer && !accountId.valid) || (!existingCustomer && !companyName.valid)">                        {{'signUpCustomerType.continue' | translate}}</button>
                    <!-- <a href="" class="small link-success" (click)="backToLogin();"><small>{{'resetPassword.backToLogin' | translate }}</small></a> -->

                </div>

            </div>

        </div>
        <!-- <div class="col-sm-3 col-md-3 col-lg-4"></div> -->
    </div>
</div>

